"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ItemMatchedRule_1 = require("@features/ItemLogPage/components/OverallList/ItemMatchedRule");
function ItemMatchedRules(_a) {
    var _b, _c;
    var job = _a.job, openModal = _a.openModal, overrideClasses = _a.overrideClasses;
    var t = (0, react_i18next_1.useTranslation)().t;
    var matchedRules = ((_c = (_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.processingResults) || [];
    return (react_1.default.createElement("div", { className: (overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.wrapper) || 'eva-search-list-view-info-item' },
        react_1.default.createElement("div", { className: (overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.label) || 'eva-search-view-label' }, t('ITEM.RULES')),
        react_1.default.createElement("a", { className: (overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.link) || 'eva-search-view-link', onClick: openModal },
            react_1.default.createElement(ItemMatchedRule_1.ItemMatchedRule, { rules: matchedRules }))));
}
exports.default = ItemMatchedRules;
